import React from 'react';
import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { TeacherRegisterData } from '../../../../../types/auth';

const TeacherPersonalStep = () => {
  const { control, formState: { errors } } = useFormContext<TeacherRegisterData>();

  return (
    <>
      <Controller
        name="teacherData.firstName"
        control={control}
        rules={{
          required: 'First name is required',
        }}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            required
            fullWidth
            id="firstName"
            label="First Name"
            autoComplete="given-name"
            error={!!errors.teacherData?.firstName}
            helperText={errors.teacherData?.firstName?.message}
            inputProps={{ 'data-testid': 'teacher-firstName-input' }}
          />
        )}
      />

      <Controller
        name="teacherData.lastName"
        control={control}
        rules={{
          required: 'Last name is required',
        }}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            required
            fullWidth
            id="lastName"
            label="Last Name"
            autoComplete="family-name"
            error={!!errors.teacherData?.lastName}
            helperText={errors.teacherData?.lastName?.message}
            inputProps={{ 'data-testid': 'teacher-lastName-input' }}
          />
        )}
      />

      <Controller
        name="teacherData.school"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            fullWidth
            id="school"
            label="School/Institution (Optional)"
            autoComplete="organization"
            error={!!errors.teacherData?.school}
            helperText={errors.teacherData?.school?.message}
            inputProps={{ 'data-testid': 'teacher-school-input' }}
          />
        )}
      />

      <Controller
        name="teacherData.phone"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            fullWidth
            id="phone"
            label="Phone Number (Optional)"
            autoComplete="tel"
            error={!!errors.teacherData?.phone}
            helperText={errors.teacherData?.phone?.message}
            inputProps={{ 'data-testid': 'teacher-phone-input' }}
          />
        )}
      />
    </>
  );
};

export default TeacherPersonalStep;
